module.exports = __webpack_public_path__ + "static/img/expm.fdb1675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expm.png
// module id = 1H+A
// module chunks = 1